/**
 * KoKo Jayne - Theme JavaScript
 * Modern Shopify Theme
 */

(function() {
  'use strict';

  // ============================================
  // Header Scroll Effect
  // ============================================
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    });
  }

  // ============================================
  // Mobile Menu Toggle
  // ============================================
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  
  if (mobileToggle && headerNav) {
    mobileToggle.addEventListener('click', () => {
      headerNav.classList.toggle('active');
      mobileToggle.classList.toggle('active');
    });
  }

  // ============================================
  // Scroll Animations
  // ============================================
  const animateElements = document.querySelectorAll('[data-animate]');
  
  if (animateElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animateElements.forEach(el => observer.observe(el));
  }

  // ============================================
  // Product Image Gallery
  // ============================================
  const galleryThumbs = document.querySelectorAll('.product-gallery-thumbs img');
  const galleryMain = document.querySelector('.product-gallery-main img');

  if (galleryThumbs.length > 0 && galleryMain) {
    galleryThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        galleryThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        galleryMain.src = thumb.dataset.fullImage || thumb.src;
      });
    });
  }

  // ============================================
  // Add to Cart AJAX
  // ============================================
  const addToCartForms = document.querySelectorAll('.product-form form, .quick-add-form');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          submitBtn.textContent = 'Added!';
          updateCartCount();
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        submitBtn.textContent = 'Error - Try Again';
        submitBtn.disabled = false;
        setTimeout(() => {
          submitBtn.textContent = originalText;
        }, 2000);
      }
    });
  });

  // ============================================
  // Update Cart Count
  // ============================================
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCounts = document.querySelectorAll('.cart-count');
      cartCounts.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.style.display = 'flex';
        }
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // ============================================
  // Newsletter Form
  // ============================================
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      const emailInput = newsletterForm.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        const btn = newsletterForm.querySelector('button');
        btn.textContent = 'Subscribed!';
        setTimeout(() => {
          btn.textContent = 'Subscribe';
        }, 3000);
      }
    });
  }

  // ============================================
  // Smooth Scroll for Anchor Links
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ============================================
  // Lazy Loading Images
  // ============================================
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[data-src]');
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
          }
          img.classList.add('loaded');
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // ============================================
  // Product Card Hover Effect (Touch Devices)
  // ============================================
  if ('ontouchstart' in window) {
    document.querySelectorAll('.product-card').forEach(card => {
      card.addEventListener('touchstart', () => {
        document.querySelectorAll('.product-card.touched').forEach(c => {
          if (c !== card) c.classList.remove('touched');
        });
        card.classList.toggle('touched');
      });
    });
  }

  // ============================================
  // Currency Formatting
  // ============================================
  window.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (cents / 100).toFixed(2);
    return '$' + value + ' AUD';
  };

})();

  // ============================================
  // Search Modal Toggle
  // ============================================
  const searchToggle = document.querySelector('.search-toggle');
  const searchModal = document.querySelector('.search-modal');
  const searchClose = document.querySelector('.search-modal-close');
  const searchOverlay = document.querySelector('.search-modal-overlay');
  const searchInput = document.querySelector('.search-modal-form input');

  if (searchToggle && searchModal) {
    searchToggle.addEventListener('click', () => {
      searchModal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput.focus(), 100);
    });

    const closeSearch = () => {
      searchModal.classList.remove('active');
      document.body.style.overflow = '';
    };

    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
    
    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('active')) {
        closeSearch();
      }
    });
  }
